"use client";

import { useAppSetting } from "./useBootstrap";
import { useTheme } from "@/theme";
import { isEphemeralMediaUrl } from "@/shared/helpers/media";
import type { AppAssetsContent } from "@/shared/settings";

/** Dados do bootstrap compartilhados por todas as variantes de header. */
export function useHeaderData() {
    const theme = useTheme();
    const assets = useAppSetting<AppAssetsContent>("app_assets");
    const themeLogo = isEphemeralMediaUrl(theme?.graphics?.logo)
        ? undefined
        : theme?.graphics?.logo;

    return {
        // O logo do tema só vale se for mídia de verdade — blob:/data: do
        // editor do portal cai no app_assets (ver isEphemeralMediaUrl).
        logoPath: themeLogo ?? assets?.logo?.url,
        logoAlt: assets?.logo?.alt ?? "Logo",
        search: theme?.components?.search,
    };
}
